// Components
import { Box, Typography } from "@mui/material";
import { SquaredAvatar } from "pages/ProjectDashboard";

// Types
import { TEntityCompany, TEntityPerson } from "pages/ProjectDashboard/components/EntityList/EntityList";

interface EntityRowProps {
    data: TEntityCompany | TEntityPerson;
    relatedButton?: JSX.Element;
    countButton?: JSX.Element;
}

const EntityRow = ({ data, relatedButton, countButton }: EntityRowProps) => {
    return (
        <>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <SquaredAvatar variant="square" size={24}>
                    <Typography>{data.createdBy}</Typography>
                </SquaredAvatar>
                <Typography
                    sx={{
                        ml: 1.4,
                        mr: 1,
                        fontSize: 11,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                    }}
                >
                    {data.name}
                </Typography>
                {relatedButton}
            </Box>
            {countButton}
        </>
    );
};

export default EntityRow;
